import React from 'react'
import {
  HiddenRadioUi,
  RadioLabelUi,
  StyledRadioUi,
} from 'src/shared/components/radio-button/ui'

export const RadioButton = ({
  checked,
  onChange,
  style,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>) => (
  <RadioLabelUi style={style}>
    <HiddenRadioUi
      type="radio"
      checked={checked}
      onChange={onChange}
      {...props}
    />
    <StyledRadioUi $checked={checked} />
  </RadioLabelUi>
)
